import {
  ChangeDetectionStrategy,
  Component,
  input,
  computed
} from '@angular/core';

import { CheckboxComponent } from '../checkbox/checkbox.component';
import { ValueAccessorProviderFactory } from '../value-accessor/value-accessor-provider-factory';
import type { InputSignal, Signal } from '@angular/core';

@Component({
  selector: 'td-wb-toggle',
  templateUrl: 'toggle.component.html',
  styleUrls: ['toggle.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [ValueAccessorProviderFactory(ToggleComponent)]
})
export class ToggleComponent extends CheckboxComponent {
  readonly toggleId: InputSignal<string | undefined> = input<string | undefined>();
  override readonly value: InputSignal<unknown> = input<unknown>();
  readonly small: InputSignal<boolean> = input<boolean>(false);
  readonly readonly: InputSignal<boolean> = input<boolean>(false);

  readonly finalToggleId: Signal<string> = computed((): string => this.toggleId() ?? this.finalCheckboxId());
}
